import React, { useState } from 'react';
import PageStore from '@/stores/page';
import MyLazyComponent from '@/common/lazy-load';

interface PropType {
  trade: TradeTypes.Root;
  i18n: DetailTypes.i18n;
}

export default function QualityCoverage(props: PropType) {
  const { trade, i18n } = props;
  const { qualityCoverage } = trade;
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;
  if (!qualityCoverage) return null;
  const IframeDialog = MyLazyComponent(() => import('../../common/dialog-iframe'));

  const [visible, setVisible] = useState(false);
  return (
    <div className="product-ta-content quality-coverage" data-taplus="qualityCoverage">
      <p className="ta-content-left">
        <img src={`${qualityCoverage.titleIcon}_40x40.jpg`} />
        <span>{qualityCoverage.title}</span>
      </p>
      <div className="ta-content-right">
        <p>
          <span
            dangerouslySetInnerHTML={{
              __html: qualityCoverage.content,
            }}
          ></span>
          <span
            className="blue-font"
            onClick={(e) => {
              e.preventDefault();
              setVisible(true);
            }}
          >
            {i18n['detail_ta_view_details']}
          </span>
        </p>
      </div>
      {isLoaded && (
        <IframeDialog
          iframeUrl={qualityCoverage.action}
          visible={visible}
          setVisible={setVisible}
          dialogClass="promotion-dialog hide-close"
        />
      )}
    </div>
  );
}
